import { useServiceError } from '@/hooks';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import {
  getMailConfiguration,
  mailConfigurationCreate,
  mailConfigurationUpdate,
  mailConfigurationUpdateVerify,
} from './MailConfigurationController.service';
import { SenderType } from './MailConfigurationController.types';

const QUERY_KEY = 'mail-configuration';

export function useMailConfiguration(
  params: {
    sender: SenderType;
    senderId?: number;
  },
  enabled = true,
) {
  const query = useQuery(
    [QUERY_KEY, { ...params }],
    () => getMailConfiguration({ ...params }),
    { enabled: !!params.sender && enabled, cacheTime: 0 },
  );

  useServiceError(query.error);

  return query;
}

export function useMailConfigurationCreate() {
  const queryClient = useQueryClient();

  const mutation = useMutation(mailConfigurationCreate, {
    async onSuccess(data) {
      notification.success({
        message: 'Sucesso!',
        description: 'Configuração do email cadastrada com sucesso',
      });

      await queryClient.invalidateQueries([QUERY_KEY, { sender: data.sender }]);
    },

    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}

export function useMailConfigurationUpdate() {
  const queryClient = useQueryClient();

  const mutation = useMutation(mailConfigurationUpdate, {
    async onSuccess(data) {
      notification.success({
        message: 'Sucesso!',
        description: 'Configuração do email alterada com sucesso',
      });

      await queryClient.invalidateQueries([QUERY_KEY, { sender: data.sender }]);
    },

    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}

export function useMailConfigurationVerify() {
  const mutation = useMutation(mailConfigurationUpdateVerify, {
    async onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: 'E-mail configurado com sucesso.',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}
